contenteditable.$inject = [];

/* @ngInject */
function contenteditable() {
    // Usage:
    //
    // Creates:
    //
    return {
        link: link,
        restrict: 'A',
        require: 'ngModel',
        scope: {
            numeric: '=contentNumeric'
        }
    };

    function link(scope, element, attrs, ngModel) {
        function read() {
            ngModel.$setViewValue(element.html());
        }

        var numeric = attrs.contentNumeric !== undefined;

        ngModel.$render = function () {
            element.html(ngModel.$viewValue || '');
        };

        element.bind('blur keyup change', function () {
            scope.$apply(read);
        });
        if (numeric) {
            element.bind('keydown', function (e) {
                var key = e.key;
                var verified = (key.length === 1 && key.match(/[^0-9]/));
                if (verified || e.which === 13) {
                    e.preventDefault();
                }
            });
        }
    }
}

export default contenteditable;